// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#recommendations[data-v-258784da] {\n\tpadding: 28px 30px 0 50px;\n\tmargin-bottom: 20px;\n\tdisplay: flex;\n\theight: 82px;\n\toverflow: hidden;\n\tflex-wrap: wrap;\n\tmin-width: 0;\n}\n\n/* show 2 per line for screen sizes smaller that 1200px */\n@media only screen and (max-width: 1200px) {\n#recommendations[data-v-258784da] {\n\t\theight: initial;\n\t\tmax-height: 189px;\n}\n}\n", ""]);
// Exports
module.exports = exports;
